const getCart = async () => {
  return await fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const countInStockItems = () => {
  let inStockCount = 0;
  document.querySelectorAll('input[name="availability"]').forEach(input => {
    if (input.value === "true") {
      inStockCount += parseInt(input.getAttribute('data-quantity'), 10);
    }
  });
  return inStockCount;
};

(() => {
  window.addEventListener('click', e => {
    if (!e.target.closest('[href]') || !e.target.closest('.shopify-section')) return;
    
    localStorage.setItem('clicked_section', `${e.target.closest('.shopify-section').classList}`.replace('shopify-section', '').replace('section', ''));
  })
  
  const getData = () => {
    return new Promise(( resolve, reject ) => {
      const tracking = JSON.parse(document.querySelector('[data-adobe-variables]').content.textContent);
      tracking.pageInfo.deviceType = navigator.userAgent;
      tracking.pageInfo.siteType = window.matchMedia('(min-width: 768px)').matches ? `Desktop web` : `Mobile web`;
      if (localStorage.getItem('clicked_section')) {
        tracking.pageInfo.referringClickLocation = localStorage.getItem('clicked_section');
      }
      
      if (document.querySelector('[data-announcement-campaign-id]')) {
        tracking.pageInfo.teaserCampaignID = document.querySelector('[data-announcement-campaign-id]').dataset.announcementCampaignId;
      }
      
      if (document.querySelector('[data-announcement-promo-code]')) {
        tracking.pageInfo.promoCode = document.querySelector('[data-announcement-promo-code]').dataset.announcementPromoCode;
      }
      
      tracking.urlInfo = {
        ...tracking.urlInfo,
        protocol: window.location.protocol,
        subDomain: null, 
        domain: window.location.hostname,
        pagePath: window.location.pathname,
        queryStringParameters: window.location.search,
        urlFull: window.location.href
      };
      
      if (window.location.pathname.includes('products/')) {
        //  product info about the product description
        const descriptionWrapper = document.querySelector('[data-accordion-id="description"]>div');
        const wordCount = descriptionWrapper?.querySelector('span')?.innerText?.split(' ')?.length ?? 0;
        const listItemCount = [...descriptionWrapper?.querySelectorAll('li')].length ?? 0;
        tracking.productInfo.productDetail = {
          "descWordCount": wordCount,
          "bulletPointCount": listItemCount
        };
        
        //  review info parsed from power reviews
        const count = document.querySelector('.pr-snippet-review-count')?.innerText.replace('Reviews', '').trim() ?? 0;
        const avgScore = document.querySelector('.pr-snippet-rating-decimal')?.innerText.trim() ?? 0;
        const reccPercent = document.querySelector('.pr-reco-value')?.innerText.replace('%', '').trim() ?? 0;
        const bestUse = document.querySelector('.pr-review-snapshot-msq-bestuses dd')?.innerText.replace(/[0-9]/g, '') ?? '';
        const comfortVsStyle = document.querySelector('.pr-review-snapshot-msq-comfortvsstyle dd')?.innerText.replace(/[0-9]/g, '') ?? '';
        const describeSelf = document.querySelector('.pr-review-snapshot-msq-describeyourself dd')?.innerText.replace(/[0-9]/g, '') ?? '';
        const bodyType = document.querySelector('.pr-review-snapshot-msq-whatbodytypedescribesyoubest dd')?.innerText.replace(/[0-9]/g, '') ?? '';
        tracking.productInfo.reviewSnapshot = {
          "reviewCount": count,
          "reviewAvgScore": avgScore,
          "referFriendPercent": reccPercent,
          "reviewBestUse": bestUse,
          "reviewComfortStyle": comfortVsStyle,
          "reviewDescribeSelf": describeSelf,
          "reviewSelfBody": bodyType
        };        
      }
    
      if (window.location.pathname.includes('account')) {
        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            return response.json();
          })
          .then((data) => {
            tracking.signInInfo.bagID = data.token;
            localStorage.setItem('bagId', data.token);
          })
          .then(() => {
            resolve(tracking);
          })
          .catch(err => reject(err));
      } 
      
      getCart()
        .then(({
          token,
          items,
          item_count,
          items_subtotal_price,
        }) => {
          const inStockBagItemCount = countInStockItems();
      
          tracking.bagInfo = {
            "event": "bagInfo",
            "bagId": token,
            "bagItemCount": items?.length ?? 0,
            "bagItems": items?.map(({ 
              original_price, 
              quantity, 
              sku 
            }) => ({
              "price": Number(original_price) / 100,
              "quantity": quantity,
              "skuCode": `${sku}`
            })) ?? [],
            "bagQuantity": item_count,
            "bagSubTotal": items_subtotal_price / 100,
            "inStockBagItemCount": inStockBagItemCount
          };
        })
        .then(() => {
          resolve(tracking);
        })
        .catch(err => reject(err));
    })
  }
  
  const pushData = (tracking) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event" : "pageInfo",
      "pageInfo": tracking.pageInfo,
      "urlInfo": tracking.urlInfo
    });      
    
    if (window.location.pathname.includes('product')) {
      poll(() => {
        return document.querySelector('bread-crumbs:not(:has(intersection-loader))');
      }, 10000, 150).then(() => {
        const breadcrumbs = document.querySelector('bread-crumbs:not(:has(intersection-loader))');
      
        if (breadcrumbs) {
          const breadcrumb = [...breadcrumbs.querySelectorAll('ul>*')].map((el, i) => (el.innerText.trim()));
          window.dataLayer.push({
            "event": "breadcrumbInfo",
            breadcrumb
          });
        }
        
        window.dispatchEvent(new Event('adobeEvent'));
      });
      
      window.dataLayer.push({
        "event": "productInfo",
        "productInfo": tracking.productInfo,
        "colorInfo": tracking.colorInfo,
        "sizeInfo": {
          ...tracking.sizeInfo,
          "percentInStock": tracking.sizeInfo.inStockCount / tracking.sizeInfo.sizeCount,
          "percentOutOfStock": tracking.sizeInfo.outOfStockCount / tracking.sizeInfo.sizeCount
        }
      });
      window.dispatchEvent(new Event('adobeEvent'));

      window.dataLayer.push({
        "event": "productPricing",
        ... tracking.productPricing
      });
    }
    
    if (window.location.pathname.includes('search') || window.localStorage.getItem('clicked_predictive_search_suggestion')) {
      if (window.localStorage.getItem('clicked_predictive_search_suggestion')) {
        tracking.internalSearch.internalSearchSuggestionSelected = window.localStorage.getItem('clicked_predictive_search_suggestion');
        tracking.internalSearch.internalSearchType = "Redirect";
        tracking.internalSearch.internalSearchQuery = window.localStorage.getItem(`redirect_query_predictive_search`);
        window.localStorage.removeItem(`clicked_predictive_search_suggestion`);
        window.localStorage.removeItem(`redirect_query_predictive_search`);
      } else {
        tracking.internalSearch.internalSearchType = "Search";
      }
      if (window.localStorage.getItem(`predictive_search_used`)) {
        tracking.internalSearch.internalSearchUsed = true;
        window.localStorage.removeItem(`predictive_search_used`);
      } else {
        tracking.internalSearch.internalSearchUsed = null;
      }
      window.dataLayer.push({
        "event": "internalSearch",
        ... tracking.internalSearch
      });
    }
    
    if (window.location.pathname.includes('cart')) {
      window.dataLayer.push({
        "event": "bagInfo",
        ... tracking.bagInfo
      });
    }
    
    if (window.location.pathname.includes('account')) {
      window.dataLayer.push({
        "event": "signInInfo",
        ... tracking.signInInfo
      });
    }
    
    window.dispatchEvent(new Event('adobeEvent'));
  }
  
  poll(() => {
    return document.querySelector('[data-adobe-variables]') && window.alloy && document.readyState === 'complete';
  }, 10000, 150).then(() => {
    getData().then((res) => {
      pushData(res);  
    });
    
    window.addEventListener('minicart:opened', (e) => {
      getCart().then(({
        token,
        items,
        item_count,
        items_subtotal_price,
      }) => {
        const inStockBagItemCount = countInStockItems();
    
        window.dataLayer.push({
          "event": "bagInfo",
          "bagId": token,
          "bagItemCount": items?.length ?? 0,
          "bagItems": items?.map(({ 
            original_price, 
            quantity, 
            sku 
          }) => ({
            "price": Number(original_price) / 100,
            "quantity": quantity,
            "skuCode": `${sku}`
          })) ?? [],
          "bagQuantity": item_count,
          "bagSubTotal": items_subtotal_price / 100,
          "inStockBagItemCount": inStockBagItemCount
        });
      });
    });
    
    window.addEventListener("message", (e) => {
      if (e.origin === `https://cdn.prod.us.five9.net`) {
        if (!e?.data?.publishEvent?.appState?.type) return;
        let flag = true;
        if (e.data.publishEvent.appState.type === "openView" && flag) {
          flag = false;
          window.dataLayer.push({
            "event": "chatBotInteraction",
            "chatBot": true
          });
          window.dispatchEvent(new Event('adobeEvent'));
        }
      }
      
      if (e.origin === `https://creatives.attn.tv`) {
        if ((e?.data?.__attentive?.action === "IMPRESSION" && e?.data?.__attentive?.pageType === "spin_to_win")) {
          window.dataLayer.push({
            "event": "spinToWinPopup",
            "spinToWinView": true
          });
          
          window.dispatchEvent(new Event('adobeEvent'));
        }
        
        if ((e?.data?.__attentive?.action === "CREATIVE_PAGE_VIEW" && e?.data?.__attentive?.pageType === "field_capture")) {
          if (e.data.__attentive.pageDataPoints.find(x => x === "email")) {
            window.dataLayer.push({
              "event": "spinToWinInteraction",
              "spinToWinInteraction": true
            });
            
            window.dispatchEvent(new Event('adobeEvent'));
          }
        }         
      }
    })
    
    window.addEventListener('productForm:plusSizeSelectedChanged', (e) => {
      getData().then((res) => {
        window.dataLayer.push({
          "event": "plusSizeSelectedChanged",
          "plusSizeSelected": true
        });
        window.dispatchEvent(new Event('adobeEvent'));
      });
    });
    
    window.addEventListener('productForm:sizeChange', (e) => {
      getData().then((res) => {
        window.dataLayer.push({
          "event": "sizeChanged",
          "inStockSizes": res?.sizeInfo?.inStockSizes ?? [],
          "outOfStockSizes": res?.sizeInfo?.outOfStockSizes ?? [],
          ...e.detail
        });
        window.dispatchEvent(new Event('adobeEvent'));
      });
    });
    
    window.addEventListener('productForm:skuChange', (e) => {
      window.dataLayer.push({
        "event": "skuCodeChanged",
        ...e.detail
      });
      window.dispatchEvent(new Event('adobeEvent'));
    });
        
    window.addEventListener('productForm:colorChange', (e) => {
      getData().then((res) => {
        window.dataLayer.push({
          "event": "colorChanged",
          "inStockColorCodeSwatchList": res?.colorInfo?.inStockColorCodeSwatchList ?? "",
          "outOfStockColorCodeSwatchList": res?.colorInfo?.outOfStockColorCodeSwatchList ?? "",
          ...e.detail
        });
        window.dispatchEvent(new Event('adobeEvent'));
      });
    });
    
    window.addEventListener('productList:productsDisplay', (e) => {
      window.dataLayer.push({
        "event": "productsDisplay",
        ...e.detail
      });
      window.dispatchEvent(new Event('adobeEvent'));
    });
    
    window.addEventListener('cart:cartChanged', (e) => {
      window.dataLayer.push({
        "event": "bagChanged",
        ...e.detail
      });
      window.dispatchEvent(new Event('adobeEvent'));
    });
    
    window.addEventListener('cart:cartAddItem', (e) => {
      window.dataLayer.push({
        "event": "bagAddItem",
        ...e.detail
      });
      window.dispatchEvent(new Event('adobeEvent'));
    });
    
    window.addEventListener('productForm:quickView', (e) => {
      window.dataLayer.push({
        "event": "productInfo",
        "productInfo": {
          ...e.detail
        }
      });
      window.dispatchEvent(new Event('adobeEvent'));
    });
  }).catch((err) => {
    console.error('Adobe Tracking data layer was not found. Check that the snippet "adobe-tracking.liquid" is included on the page. Errors: ', err)
  })
}) ();